module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get.fd144ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time-attendance/fullscreen-image_lets-get.png
// module id = 6CRL
// module chunks = 0